import { render, staticRenderFns } from "./OmniverseOnboardingSteps.vue?vue&type=template&id=8d5eff16"
import script from "./OmniverseOnboardingSteps.vue?vue&type=script&lang=ts"
export * from "./OmniverseOnboardingSteps.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports